<script setup lang="ts">
   //state
   import { ref } from 'vue';
   import ProgressSpinner from 'primevue/progressspinner';

   const visible = ref(false);
   const iframeSrc = ref('');
   const isLoading = ref(false);
   const modalTitle = ref('');

   type Link = {
      url: string;
      anchor: string;
   };
   const termlyLinks: Link[] = [
      {
         url: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=c23fd64f-5f81-4ace-af10-566d19afb83a',
         anchor: 'The Terms of Use',
      },
      {
         url: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=713d2c43-597d-42a8-9314-7a605d06a91a',
         anchor: 'Privacy Policy',
      },
      {
         url: 'https://app.termly.io/policy-viewer/policy.html?policyUUID=4179495c-4a4f-4c09-a6b2-894b27bf9654',
         anchor: 'Cookie Policy',
      },
      {
         url: `https://app.termly.io/document/disclaimer/4679a154-e6d6-4900-92a1-4ff3d3bce91c`,
         anchor: `Disclaimer`,
      },
   ];

   //functions
   function handleClick(link: Link) {
      iframeSrc.value = link.url;
      modalTitle.value = link.anchor;
      isLoading.value = true;
      visible.value = true;
   }

   function onIframeLoad() {
      isLoading.value = false;
   }
</script>

<template>
   <Dialog
      v-model:visible="visible"
      modal
      :header="modalTitle"
      class="w-full max-w-4xl overflow-hidden"
      style="height: 54vh"
      :pt="{
         content: { class: 'h-full overflow-auto p-0' },
      }">
      <div class="relative flex h-full items-center justify-center">
         <ProgressSpinner v-if="isLoading" />
         <iframe
            v-show="!isLoading"
            :src="iframeSrc"
            style="height: 100%; width: 100%; border: none"
            @load="onIframeLoad"></iframe>
      </div>
   </Dialog>
   <ul
      class="mt-7 flex flex-col border-t border-white border-opacity-70 pt-7 text-sm sm:flex-row sm:divide-x-2 sm:divide-white sm:divide-opacity-50">
      <li v-for="link in termlyLinks" class="border-b border-white border-opacity-50 sm:border-b-0">
         <button @click="handleClick(link)" class="w-full text-left sm:text-center">
            <span class="flex px-4 py-3 sm:px-7 sm:py-2">{{ link.anchor }}</span>
         </button>
      </li>
   </ul>
</template>

<style scoped></style>
